export default "__VITE_ASSET__DF10u71P__"